export const ecosystemServices = [
  {
    id: "69ba27b11c51b126caa87b66",
    slug: "digital-infrastructure-and-cloud-transformation",
    name: "Digital Infrastructure & Cloud Transformation",
    title: "Digital Infrastructure & Cloud Transformation",
    description: "Providing comprehensive digital infrastructure solutions based on international-standard Cloud Computing platforms. Services help businesses optimize operational costs, enhance system scalability, and ensure High Availability for mission-critical applications.",
    category: "Technology",
    icon: "Cloud",
    features: [
      "Hybrid Cloud Management",
      "Data Center Migration",
      "Auto-scaling Infrastructure"
    ],
    themeColor: "#0ea5e9",
    isActive: true,
    order: 0
  },
  {
    id: "69ba27d01c51b126caa87b68",
    slug: "enterprise-cybersecurity-audit-and-protection",
    name: "Enterprise Cybersecurity Audit & Protection",
    title: "Enterprise Cybersecurity Audit & Protection",
    description: "In-depth cybersecurity assessment services to identify and prevent potential security vulnerabilities. We deploy multi-layered defense systems, from Penetration Testing to 24/7 security monitoring, to protect your business's valuable data assets.",
    category: "Security",
    icon: "ShieldCheck",
    features: [
      "Vulnerability Assessment",
      "Incident Response",
      "Compliance Auditing"
    ],
    themeColor: "#10b981",
    isActive: true,
    order: 0
  },
  {
    id: "69ba27de1c51b126caa87b6a",
    slug: "ai-powered-business-intelligence",
    name: "AI-Powered Business Intelligence",
    title: "AI-Powered Business Intelligence",
    description: "Unlocking the power of raw data through Machine Learning and Artificial Intelligence models. Our solutions help businesses build real-time Dashboards, forecast market trends, and make data-driven strategic decisions.",
    category: "Technology",
    icon: "BrainCircuit",
    features: [
      "Predictive Analytics",
      "Data Visualization",
      "Natural Language Processing"
    ],
    themeColor: "#8b5cf6",
    isActive: true,
    order: 0
  },
  {
    id: "69ba27e71c51b126caa87b6c",
    slug: "custom-erp-and-software-solutions",
    name: "Custom ERP & Software Solutions",
    title: "Custom ERP & Software Solutions",
    description: "Developing tailor-made Enterprise Resource Planning (ERP) systems and custom software to optimize business workflows, automate repetitive tasks, and ensure seamless integration with existing systems.",
    category: "Technology",
    icon: "Code2",
    features: [
      "Workflow Automation",
      "API Integration",
      "Legacy Modernization"
    ],
    themeColor: "#3b82f6",
    isActive: true,
    order: 0
  },
  {
    id: "69ba27f01c51b126caa87b6e",
    slug: "digital-marketing-and-brand-positioning",
    name: "Digital Marketing & Brand Positioning",
    title: "Digital Marketing & Brand Positioning",
    description: "Building multi-channel digital brand strategies combining creative thinking and performance data analysis. Focused on increasing customer touchpoints, Conversion Rate Optimization (CRO), and building brand loyalty.",
    category: "Marketing",
    icon: "TrendingUp",
    features: [
      "Omnichannel Strategy",
      "Performance Marketing",
      "Content Ecosystem"
    ],
    themeColor: "#f43f5e",
    isActive: true,
    order: 0
  },
  {
    id: "69ba27f71c51b126caa87b70",
    slug: "real-estate-digital-management",
    name: "Real Estate Digital Management",
    title: "Real Estate Digital Management",
    description: "Smart real estate management solutions, integrating VR/AR and digital maps for transparency in project information. Helping developers track construction progress and optimize customer experience.",
    category: "Real Estate",
    icon: "Building2",
    features: [
      "Project Tracking",
      "Smart Contract Integration",
      "Virtual Tour Setup"
    ],
    themeColor: "#64748b",
    isActive: true,
    order: 0
  },
  {
    id: "69ba28011c51b126caa87b72",
    slug: "strategic-corporate-consulting",
    name: "Strategic Corporate Consulting",
    title: "Strategic Corporate Consulting",
    description: "Corporate restructuring and operational model optimization consulting for fluctuating market conditions. We partner with leadership to identify new growth drivers.",
    category: "Consulting",
    icon: "Presentation",
    features: [
      "Business Transformation",
      "ESG Framework",
      "Operational Excellence"
    ],
    themeColor: "#f59e0b",
    isActive: true,
    order: 0
  },
  {
    id: "69ba28091c51b126caa87b74",
    slug: "e-learning-and-corporate-training-platforms",
    name: "E-learning & Corporate Training Platforms",
    title: "E-learning & Corporate Training Platforms",
    description: "Modern LMS helping businesses automate internal training processes and personalize learning paths. Supporting effective knowledge base management for organizations.",
    category: "EdTech",
    icon: "GraduationCap",
    features: [
      "Personalized Learning",
      "Skills Assessment",
      "Mobile Learning App"
    ],
    themeColor: "#22c55e",
    isActive: true,
    order: 0
  },
  {
    id: "69ba280f1c51b126caa87b76",
    slug: "supply-chain-data-integration",
    name: "Supply Chain Data Integration",
    title: "Supply Chain Data Integration",
    description: "Optimizing supply chain by connecting data from suppliers to end customers. Solutions ensure transparency and minimize risks in global logistics operations.",
    category: "Logistics",
    icon: "Truck",
    features: [
      "Inventory Forecasting",
      "Supplier Management",
      "Real-time Tracking"
    ],
    themeColor: "#d97706",
    isActive: true,
    order: 0
  },
  {
    id: "69ba28141c51b126caa87b78",
    slug: "corporate-media-production",
    name: "Corporate Media Production",
    title: "Corporate Media Production",
    description: "Professional digital content production, from corporate videos to premium visual communication campaigns. Combining storytelling and modern technology to inspire brands.",
    category: "Media",
    icon: "Video",
    features: [
      "Video Storytelling",
      "Brand Photography",
      "Social Media Content"
    ],
    themeColor: "#7c3aed",
    isActive: true,
    order: 0
  },
];

export const ecosystemStats = [
  {
    id: "kinh-nghiem",
    value: 10,
    suffix: "+",
    label: "Years of Experience",
    icon: "ShieldCheck",
  },
  {
    id: "du-an",
    value: 500,
    suffix: "+",
    label: "Completed Projects",
    icon: "Rocket",
  },
  {
    id: "chuyen-gia",
    value: 100,
    suffix: "+",
    label: "IT Experts",
    icon: "Users",
  },
  {
    id: "doi-tac",
    value: 50,
    suffix: "+",
    label: "Global Partners",
    icon: "Globe",
  },
];
